import api from "./index"
import {
  ICheckAuthorizeByPhoneBody,
  IAuthorizeByOtpBody,
} from "./mutations/auth/authMutationsTypes"

const checkAuthorizeByPhone = (data: ICheckAuthorizeByPhoneBody) =>
  api.post("/account/checkAuthorizeByPhone", data)

const authorizeByOtp = (fcmToken: string, data: IAuthorizeByOtpBody) =>
  api.post(`/account/authorizeByOtp/${fcmToken}`, data)

const removeFireBaseToken = (fcmToken: string, authToken: string | null) =>
  api.delete(`/Account/RemoveFireBaseToken/${fcmToken}`, {
    headers: {
      Authorization: `Bearer ${authToken}`,
    },
  })

export default {
  checkAuthorizeByPhone,
  authorizeByOtp,
  removeFireBaseToken,
}
